export default __webpack_public_path__ + "static/media/ceo2-portrait.de7b5e2d.png";